import {
  STACK_CENTER_COLUMN_DIRECTION,
  STACK_CENTER_ROW_DIRECTION,
  STACK_START_ROW_DIRECTION,
  INFORMATION_STACK_WITH_BORDER,
  INFORMATION_STACK_NO_BORDER,
  STACK_CENTER,
  STACK_START_COLUMN_DIRECTION,
  STACK_SPACE_BETWEEN_ROW_DIRECTION,
  STACK_PRODUCT_SECTION_COMPONENT,
} from '../../constants/mui-components';

const MuiStack = {
  styleOverrides: {
    root: ({ theme }) => ({
      [`&.${STACK_CENTER}`]: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
      [`&.${STACK_CENTER_COLUMN_DIRECTION}`]: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      },
      [`&.${INFORMATION_STACK_WITH_BORDER}`]: {
        padding: '0.5rem 1rem',
        borderRadius: '6.25rem',
        border: '1px solid white',
      },
      [`&.${INFORMATION_STACK_NO_BORDER}`]: {
        padding: '0.5rem 1rem',
        borderRadius: '6.25rem',
      },
      [`&.${STACK_CENTER_ROW_DIRECTION}`]: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
      },
      [`&.${STACK_START_COLUMN_DIRECTION}`]: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'center',
      },
      [`&.${STACK_START_ROW_DIRECTION}`]: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        justifyContent: 'center',
      },
      [`&.${STACK_SPACE_BETWEEN_ROW_DIRECTION}`]: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
      },
      [`&.${STACK_PRODUCT_SECTION_COMPONENT}`]: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '4rem 1rem 0 1rem',
        gap: '3rem',
        [theme.breakpoints.up('md')]: {
          padding: '4.5rem 3.75rem',
          gap: '6.5rem',
        },
      },
    }),
  },
};

export default MuiStack;
